import {Inject, Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {share} from 'rxjs/operators';
import {UserServiceInterface} from './user.service.interface';
import {DA_STORE_USER, UserStore} from './user.store.interface';
import {User} from './user.interface';
import {BASE_CLIENT, BaseClient} from '../client/base.client';
import {TokenService} from '../token/token.service';
import {DA_SERVICE_TOKEN} from "../token/token.interface";

const STORE_KEY = 'user';

@Injectable({
  providedIn: 'root'
})
export class UserService implements UserServiceInterface {

  constructor(
    @Inject(DA_STORE_USER) private store: UserStore,
    @Inject(BASE_CLIENT) private client: BaseClient,
    @Inject(DA_SERVICE_TOKEN) private tokenService: TokenService) {
  }

  private change$: BehaviorSubject<User> = new BehaviorSubject<User>(null);

  set(data: User): boolean {
    this.change$.next(data);
    return this.store.set(STORE_KEY, data);
  }

  // tslint:disable-next-line:no-any
  get(type?: any): User;
  get<T extends User>(type?: { new(): T }): T {
    const data = this.store.get(STORE_KEY);
    return type ? (Object.assign(new type(), data) as T) : (data as T);
  }

  clear() {
    this.change$.next(null);
    this.store.remove(STORE_KEY);
  }

  change(): Observable<User> {
    return this.change$.pipe(share());
  }

  logout(): void {
    this.tokenService.set(null);
    this.tokenService.clear();
    window.location.href = `${this.client.gateway}/cas-proxy/app/logout`;
  }

  getConfig(): any {
    if (this.get().menu) {
      return JSON.parse(this.get().menu[0].attribute);
    } else {
      return null;
    }
  }

  getMenus(): any[] {
    return this.get().menu || [];
  }

  findMenuBySystemCode(menus: any[], systemCode: string) {
    let targetMenu = menus.find(item => item.systemCode === systemCode);
    if (targetMenu != null) {
      return targetMenu;
    }
    for (let i = 0; i < menus.length; i++) {
      const menu = menus[i];
      let targetSubMenu = this.findMenuBySystemCode(menu.children || [], systemCode);
      if (targetSubMenu != null) {
        return targetSubMenu;
      }
    }
    return null;
  }

}

